import * as corporateOnboardingAction from './action';
const initialState = {
    creditLimitModelList: [],
    creditLimitModelListError: [],
    productSectionList: [],
    productSectionListError: [],
    riskFactors: [],
    riskFactorsError: [],
    statesListSuccessData: null,
    statesListFailure: null,
    companySetup: {},
    scorecardData: [],
    productSetup: {},
    corporateOnboardingSuccess: {},
    corporateOnboardingFailure: {},
    editData: [],
    editDataError: [],
    editCorporateOnboardingSuccess: {},
    editCorporateOnboardingFailure: {},
    corporateOnboardingStatus: false,
    result: {},
    defaultProductsAddedResponse: {},
    creditSetup: "",
    fetchMisFieldListSuccess: null,
    fetchMisFieldListFailure: null,
    misFieldSetupData: [],
    fetchMisFieldListByCorpIdFailure: null,
    fetchDefaultMisFieldListSuccess: null,
    fetchDefaultMisFieldListFailure: null,
    fetchEwsSelectPlanNameSuccess: null,
    fetchEwsSelectPlanNameFailure: null,
}
const corporateOnboardingCreateReducer = (state = initialState, action) => {
    switch (action.type) {
        case corporateOnboardingAction.GET_STATES_LIST_SUCCESS:
            return state = {
                ...state,
                statesListSuccessData: action.data
            }
        case corporateOnboardingAction.GET_STATES_LIST_FAILURE:
            return state = {
                ...state,
                statesListFailure: action.data
            }
        case corporateOnboardingAction.SET_COMPANY_SETUP:
            return state = {
                ...state,
                companySetup: action.data
            }
        case corporateOnboardingAction.SET_CORPORATE_ONBOARDING_STATUS:
            return state = {
                ...state,
                corporateOnboardingStatus: action.data
            }
        case corporateOnboardingAction.SET_PRODUCT_SETUP_DATA:
            return state = {
                ...state,
                productSetup: action.data
            }
        case corporateOnboardingAction.FETCH_PRODUCT_SECTION_LIST_SUCCESS:
            return state = {
                ...state,
                productSectionList: action.data
            }
        case corporateOnboardingAction.FETCH_PRODUCT_SECTION_LIST_FAILURE:
            return state = {
                ...state,
                productSectionListError: action.data
            }
        case corporateOnboardingAction.FETCH_CREDIT_LIMIT_MODEL_LIST_SUCCESS:
            return state = {
                ...state,
                creditLimitModelList: action.data
            }
        case corporateOnboardingAction.FETCH_CREDIT_LIMIT_MODEL_LIST_FAILURE:
            return state = {
                ...state,
                creditLimitModelListError: action.data
            }
        /* case corporateOnboardingAction.FETCH_RISKGRADE_CATEGORY_LIST_SUCCESS:
            return state = {
                ...state,
                riskLevels: action.data
            }
        case corporateOnboardingAction.FETCH_RISKGRADE_CATEGORY_LIST_FAILURE:
            return state = {
                ...state,
                riskLevelsError: action.error
            } */
        case corporateOnboardingAction.FETCH_RISKFACTORS_SUCCESS:
            return state = {
                ...state,
                riskFactors: action.data
            }
        case corporateOnboardingAction.FETCH_RISKFACTORS_FAILURE:
            return state = {
                ...state,
                riskFactorsError: action.error
            }
        case corporateOnboardingAction.CORPORATE_ONBOARDING_SUCCESS:
            return state = {
                ...state,
                corporateOnboardingSuccess: action.data
            }
        case corporateOnboardingAction.CORPORATE_ONBOARDING_FAILURE:
            return state = {
                ...state,
                corporateOnboardingFailure: action.error
            }
        case corporateOnboardingAction.ONE_CLICK_CORPORATE_ONBOARDING_SUCCESS:
            return state = {
                ...state,
                result: action
            }
        case corporateOnboardingAction.ONE_CLICK_CORPORATE_ONBOARDING_FAILURE:
            return state = {
                ...state,
                result: action
            }
        case corporateOnboardingAction.ADD_DEFAULT_PRODUCTS_SUCCESS:
            return state = {
                ...state,
                defaultProductsAddedResponse: action
            }
        case corporateOnboardingAction.ADD_DEFAULT_PRODUCTS_FAILURE:
            return state = {
                ...state,
                defaultProductsAddedResponse: action
            }
        case corporateOnboardingAction.SAVE_SCORECARD_DATA:
            return state = {
                ...state,
                scorecardData: action.data
            }
        case corporateOnboardingAction.GET_EDIT_DATA_SUCCESS:
            return state = {
                ...state,
                editData: action.data
            }
        case corporateOnboardingAction.GET_EDIT_DATA_FAILURE:
            return state = {
                ...state,
                editDataError: action.data
            }
        case corporateOnboardingAction.SET_CREDIT_SETUP:
            return state = {
                ...state,
                creditSetup: action.data
            }
        case corporateOnboardingAction.CORPORATE_ONBOARDING_EDIT_SUCCESS:
            return state = {
                ...state,
                editCorporateOnboardingSuccess: action.data
            }
        case corporateOnboardingAction.CORPORATE_ONBOARDING_EDIT_FAILURE:
            return state = {
                ...state,
                editCorporateOnboardingFailure: action.error
            }
        case corporateOnboardingAction.FETCH_MIS_FIELDS_SUCCESS:
            return state = {
                ...state,
                fetchMisFieldListSuccess: action.data
            }
        case corporateOnboardingAction.FETCH_MIS_FIELDS_FAILURE:
            return state = {
                ...state,
                fetchMisFieldListFailure: action.error
            }
        case corporateOnboardingAction.SET_MIS_FIELD_SETUP_DATA:
            return state = {
                ...state,
                misFieldSetupData: action.data
            }
        case corporateOnboardingAction.FETCH_MIS_FIELDS_BY_CORPORATE_ID_FAILURE:
            return state = {
                ...state,
                fetchMisFieldListByCorpIdFailure: action.data
            }
        case corporateOnboardingAction.SET_MIS_FIELDS:
                return state = {
                    ...state,
                    fetchMisFieldListSuccess: action.data
                }
        case corporateOnboardingAction.FETCH_DEFAULT_MIS_FIELDS_SUCCESS:
                    return state = {
                        ...state,
                        fetchDefaultMisFieldListSuccess: action.data
                    }
        case corporateOnboardingAction.SET_DEFAULT_MIS_FIELDS:
                    return state = {
                        ...state,
                        fetchDefaultMisFieldListSuccess: action.data
                    }
                    
        case corporateOnboardingAction.FETCH_DEFAULT_MIS_FIELDS_FAILURE:
            return state = {
                ...state,
                fetchDefaultMisFieldListFailure: action.error
            }

        case corporateOnboardingAction.FETCH_EWS_PLAN_NAME_LIST_SUCCESS:
            return state = {
                ...state,
                fetchEwsSelectPlanNameSuccess: action.data
            }
        case corporateOnboardingAction.FETCH_EWS_PLAN_NAME_LIST_FAILURE:
            return state = {
                ...state,
                fetchEwsSelectPlanNameFailure: action.error
            }
        case corporateOnboardingAction.SET_IS_MANDATORY_MIS_ORDERID_SETUP_DATA:
            return state = {
                ...state,
                isMandatoryMisOrderIdData: action.data
            }
        case corporateOnboardingAction.FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE_SUCCESS:
            return state = {
                ...state,
                fetchIsMisOrderIdMandatorySuccess: action.data
            }
        case corporateOnboardingAction.FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE_FAILURE:
            return state = {
                ...state,
                fetchIsMisOrderIdMandatoryFailure: action.error
            }
        default: return state;
    }
};

export default corporateOnboardingCreateReducer; 